export const DEFAULT_PREFIX = 'P3__'

//// up to date packages are like below
// SERVICE_PKG_B2, SERVICE_PKG_C, SERVICE_PKG_D, SERVICE_PKG_E
// SERVICE_PKG_AA, SERVICE_PKG_BB, SERVICE_PKG_CC
// EXTRA_SEAT_AA, EXTRA_SEAT_BB, EXTRA_SEAT_CC
/////////////////

export const freePlans = [
  'gold_free',
  'platinum_free',
  'BASIC_FREE',
  'PREMIUM_FREE',
  'UNLIMITED_AGENCY5_FREE',
  'UNLIMITED_AGENCY20_FREE',
  'UNLIMITED_AGENCY_FREE_EDUCATION',
  'WHITE_GLOVE_FREE',
  'POP_AUTHORITY_FREE',
]

export const agencyMonthlyPlans = [
  'SERVICE_PKG_F',
  'SERVICE_PKG_G',
  'SERVICE_PKG_H',
  'SERVICE_PKG_L', // special plan for agency 100 sub accounts

  // 'P1__SERVICE_PKG_F',
  // 'P1__SERVICE_PKG_G',
  // 'P1__SERVICE_PKG_H',
  
  `SERVICE_PKG_AA`,
  `SERVICE_PKG_CC`,
]

export const agencyYearlyPlans = [
  'SERVICE_PKG_I',
  'SERVICE_PKG_J',
  'SERVICE_PKG_K',
  'SERVICE_PKG_M', // special plan for agency 100 sub accounts
  
  // 'P1__SERVICE_PKG_I',
  // 'P1__SERVICE_PKG_J',
  // 'P1__SERVICE_PKG_K',
  `SERVICE_PKG_BB`,
];

export const agencyPlans = [
  ...agencyMonthlyPlans,
  ...agencyYearlyPlans,

  'UNLIMITED_AGENCY5_FREE',
  'UNLIMITED_AGENCY20_FREE',
  'UNLIMITED_AGENCY_FREE_EDUCATION',
  'WHITE_GLOVE_FREE',
  'POP_AUTHORITY_FREE',
];

export const agencyPlansWithAdditionalSeatsAvailable = [
  `SERVICE_PKG_AA`,
  `SERVICE_PKG_BB`,
  `SERVICE_PKG_CC`,
]

export const additionalSeatPlans = [
  `EXTRA_SEAT_AA`,
  `EXTRA_SEAT_BB`,
  `EXTRA_SEAT_CC`,
]

export const PURE_TRIAL_PLANS = [
  'SERVICE_PKG_A',
  'SERVICE_PKG_B2',  
]

// POP Authority: a separate account type "based on White Glove" (subscription packages per
// project). Admin-assigned like WHITE_GLOVE_FREE. Use this list (or the `isPopAuthorityUser`
// store getter) only where POP Authority diverges from White Glove.
export const popAuthorityPlans = [
  'POP_AUTHORITY_FREE',
];

// The "white glove family": every white-glove gate in the app (`isWhiteGloveUser`) uses this
// list, so POP Authority accounts get the same services and screens as White Glove by default.
export const whiteGlovePlans = [
  'SERVICE_PKG_CC',
  'WHITE_GLOVE_FREE',
  ...popAuthorityPlans,
];

export const whiteGloveAddons = [
  'WHITE_GLOVE_ADDON_CONTENT_AUDIT',
  'WHITE_GLOVE_ADDON_CONTENT_AUDIT_SPEEDY_DELIVERY',
  'POP_AUTHORITY_SETUP_FEE',
]

export const whiteGloveOnlyServices = [
  ...whiteGloveAddons,
  'WHITE_GLOVE_ADDON_PURCHASE',
  'CART_PURCHASE',
  'SILO_CONTENT_REPORTS_PURCHASE',
  'BALANCE_TOP_UP',
  'POP_AUTHORITY_BOOSTER_PURCHASE',
];


// this must be full package name mapping not pure
export const correspondingSeatPlans = {
  [`P2__SERVICE_PKG_AA`]: `P2__EXTRA_SEAT_AA`,
  [`P2__SERVICE_PKG_BB`]: `P2__EXTRA_SEAT_BB`,
  [`P2__SERVICE_PKG_CC`]: `P2__EXTRA_SEAT_CC`,
  [`${DEFAULT_PREFIX}SERVICE_PKG_AA`]: `${DEFAULT_PREFIX}EXTRA_SEAT_AA`,
  [`${DEFAULT_PREFIX}SERVICE_PKG_BB`]: `${DEFAULT_PREFIX}EXTRA_SEAT_BB`,
  [`${DEFAULT_PREFIX}SERVICE_PKG_CC`]: `${DEFAULT_PREFIX}EXTRA_SEAT_CC`,
}

export const unlimitedServices = [
  'platinum', 'UnlimitedYearly', 'platinum_free', 'gold_free',
  'SERVICE_PKG_D', 'SERVICE_PKG_E',
  ...agencyPlans,
];

export const UNLIMITED_SUBSCRIPTION_SERVICES = [
  ...unlimitedServices,
  'P1__SERVICE_PKG_D',
  'P1__SERVICE_PKG_E',
  'P1__SERVICE_PKG_F',
  'P1__SERVICE_PKG_G',
  'P1__SERVICE_PKG_H',
  'P1__SERVICE_PKG_I',
  'P1__SERVICE_PKG_J',
  'P1__SERVICE_PKG_K',
  'P2__SERVICE_PKG_D',
  'P2__SERVICE_PKG_E',
  'P2__SERVICE_PKG_AA',
  'P2__SERVICE_PKG_BB',
  'P2__SERVICE_PKG_CC',
  'P3__SERVICE_PKG_D',
  'P3__SERVICE_PKG_E',
  'P3__SERVICE_PKG_AA',
  'P3__SERVICE_PKG_BB',
  'P3__SERVICE_PKG_CC',
  'WHITE_GLOVE_FREE',
  'POP_AUTHORITY_FREE',
]

export const SUBSCRIPTIONS_WITH_ACCESS_TO_KEYWORD_RESEARCH_TOOLS = UNLIMITED_SUBSCRIPTION_SERVICES

export const SUBSCRIPTIONS_WITH_UNLIMITED_ACCESS_TO_KEYWORD_RESEARCH_TOOLS = whiteGlovePlans

export const WHITE_GLOVE_CAMPAIGN_MANAGERS = {
    'kyle': {
        'key': 'kyle',
        'first_name': 'Kyle',
    },
    'bianca': {
        'key': 'bianca',
        'first_name': 'Bianca',
    },
    'laura': {
        'key': 'laura',
        'first_name': 'Laura',
    },
    'daryl': {
        'key': 'daryl',
        'first_name': 'Daryl',
    },
}

export const AVAILABLE_SALES_TAGS = {
    'active': {
        'key': 'active',
        'label': 'Active',
    },
    'passive': {
        'key': 'passive',
        'label': 'Passive',
    },
}

export const WHITE_GLOVE_DEFAULT_CAMPAIGN_MANAGER = 'laura'

export const AVAILABLE_BALANCE_TOP_UP_OPTIONS = [
    {
        'key': 'BALANCE_TOP_UP_250',
        'price': 250,
        'top_up_amount': 250,
        'top_up_bonus': 0,
        'label': '$250',
    },
    {
        'key': 'BALANCE_TOP_UP_500',
        'price': 500,
        'top_up_amount': 500,
        'top_up_bonus': 20,
        'label': '$500 (+ $20 Bonus)'
    },
    {
        'key': 'BALANCE_TOP_UP_750',
        'price': 750,
        'top_up_amount': 750,
        'top_up_bonus': 35,
        'label': '$750 (+ $35 Bonus)'
    },
    {
        'key': 'BALANCE_TOP_UP_1000',
        'price': 1000,
        'top_up_amount': 1000,
        'top_up_bonus': 55,
        'label': '$1000 (+ $55 Bonus)'
    }
]

export const watchdogOnlyServices = [
  'P1__SERVICE_PKG_Z',
  'P2__SERVICE_PKG_Z',
  'P3__SERVICE_PKG_Z',
]

// this must be full service package name not pure
export const oldPlans = [
  'SERVICE_PKG_A', 'SERVICE_PKG_B',
  'SERVICE_PKG_B2', 'SERVICE_PKG_C', 'SERVICE_PKG_D', 'SERVICE_PKG_E',
  'SERVICE_PKG_F', 'SERVICE_PKG_G', 'SERVICE_PKG_H', 'SERVICE_PKG_I', 'SERVICE_PKG_J', 'SERVICE_PKG_K',
  'P1__SERVICE_PKG_B2', 'P1__SERVICE_PKG_C', 'P1__SERVICE_PKG_D', 'P1__SERVICE_PKG_E',
  'P1__SERVICE_PKG_F', 'P1__SERVICE_PKG_G', 'P1__SERVICE_PKG_H', 'P1__SERVICE_PKG_I', 'P1__SERVICE_PKG_J', 'P1__SERVICE_PKG_K',
  
  'P2__SERVICE_PKG_B2', 'P2__SERVICE_PKG_C', 'P2__SERVICE_PKG_D', 'P2__SERVICE_PKG_E',
  'P2__SERVICE_PKG_F', 'P2__SERVICE_PKG_G', 'P2__SERVICE_PKG_H', 'P2__SERVICE_PKG_I', 'P2__SERVICE_PKG_J', 'P2__SERVICE_PKG_K',
  // 'SERVICE_PKG_L', 'SERVICE_PKG_M',
]

export const CURRENT_YEARLY_PLANS = [
  `${DEFAULT_PREFIX}SERVICE_PKG_E`,
  `${DEFAULT_PREFIX}SERVICE_PKG_BB`,
  `${DEFAULT_PREFIX}EXTRA_SEAT_BB`,
]



export const PRICE_OF_EACH_VERSIONING = {
  'SERVICE_PKG_A': 10,
  'SERVICE_PKG_B': 20,
  'SERVICE_PKG_B2': 20,
  'SERVICE_PKG_C': 30,
  'SERVICE_PKG_D': 300,


  'P1__SERVICE_PKG_B2': 22,
  'P1__SERVICE_PKG_C': 33,
  'P1__SERVICE_PKG_D': 44,
  'P1__SERVICE_PKG_E': 440,

  'P2__SERVICE_PKG_B2': 27,
  'P2__SERVICE_PKG_C': 38,
  'P2__SERVICE_PKG_D': 49,
  'P2__SERVICE_PKG_E': 490,

  'P3__SERVICE_PKG_B2': 40,
  'P3__SERVICE_PKG_C': 47.5,
  'P3__SERVICE_PKG_D': 72,
  'P3__SERVICE_PKG_E': 739,
  'P3__SERVICE_PKG_AA': 143,
  'P3__SERVICE_PKG_BB': 1425,
  'P3__SERVICE_PKG_CC': 275,
  'P3__EXTRA_SEAT_AA': 12,
  'P3__EXTRA_SEAT_BB': 120,
  'P3__EXTRA_SEAT_CC': 12,

  // One-time purchases
  'WHITE_GLOVE_ADDON_CONTENT_AUDIT': 275,
  'WHITE_GLOVE_ADDON_CONTENT_AUDIT_SPEEDY_DELIVERY': 345,
  'POP_AUTHORITY_SETUP_FEE': 375,
}
export const PURE_PAKCAGE_TO_DISP_NAME_MAP = {
  'platinum_free': 'Unlimited',
  'SERVICE_PKG_B': 'Basic',
  'SERVICE_PKG_B2': 'Basic',
  'SERVICE_PKG_C': 'Premium',
  'SERVICE_PKG_D': 'Unlimited',
  'SERVICE_PKG_E': 'Unlimited',
}

export const ALLOWED_SILO_ORDER_DELIVERY_PERIODS = {
    3: {
        'label': '3 days'
    },
    7: {
        'label': '7 days'
    },
    14: {
        'label': '14 days'
    },
    28: {
        'label': '28 days'
    },
    60: {
        'label': '2 months'
    },
    90: {
        'label': '3 months'
    },
    120: {
        'label': '4 months'
    },
    150: {
        'label': '5 months'
    },
    180: {
        'label': '6 months'
    },
}
export const ALLOWED_SILO_ORDER_DELIVERY_PERIODS_FOR_DUE_NOW = [3, 7]
export const SILO_ORDER_DAYS_BEFORE_DUE = 7
export const SILO_ORDER_SPEEDY_DELIVERY_PERIOD = 3
export const SILO_ORDER_SPEEDY_DELIVERY_MULTIPLIER = 0.25

export const FIRST_CONTENT_ORDER_AMOUNT_OFF = 25  // $25

export const get_keyword_research_metrics_price_for_num_of_keywords = (num_of_keywords) => {
  // Price is in Credits
  if (num_of_keywords == 0) {
    return 0
  } else if (num_of_keywords >= 1 && num_of_keywords <= 3) {
    return 1
  } else if (num_of_keywords >= 4 && num_of_keywords <= 6) {
    return 2
  } else if (num_of_keywords >= 7 && num_of_keywords <= 10) {
    return 3
  } else if (num_of_keywords >= 11 && num_of_keywords <= 60) {
    return 4
  } else if (num_of_keywords >= 61 && num_of_keywords <= 100) {
    return 5
  }
  throw Error(`Unsupported num_of_keywords: ${num_of_keywords}`)
}

export const KEYWORD_RESEARCH_METRICS_PRICE_TIERS = {
  '1 - 3': get_keyword_research_metrics_price_for_num_of_keywords(3),
  '4 - 6': get_keyword_research_metrics_price_for_num_of_keywords(6),
  '7 - 10': get_keyword_research_metrics_price_for_num_of_keywords(10),
  '11 - 60': get_keyword_research_metrics_price_for_num_of_keywords(60),
  '61 - 100': get_keyword_research_metrics_price_for_num_of_keywords(100),
}

export const KEYWORD_RESEARCH_ONE_CLICK_SILO_PRICE = 4

export const GOOGLE_AI_OVERVIEW_FEATURE_PRICE = 1
export const GOOGLE_AI_OVERVIEW_FALLBACK_PRICE = 0